export const CHATBOT_SOCKET_CONNECT = 'connect';
export const CHATBOT_SOCKET_DISCONNECT = 'disconnect';
export const CHATBOT_SOCKET_MESSAGE = 'message';
export const CHATBOT_ERROR_EVENT = 'error_socket';
export const CHATBOT_OUTSIDE_MESSAGE = 'outside_message';
export const CHATBOT_OUTSIDE_AUDIO = 'outside_audio';
export const CHATBOT_TOKEN_STRING = '_utn_bot';
export const CHATBOT_CHAT_MSJ_FROM_CLIENT = 'client';
export const CHATBOT_CHAT_MSJ_FROM_BOT = 'bot';
export const CHATBOT_TOKEN_EVENT = 'jwt_token';

export const CHATBOT_ERROR_MESSAGE_MIN_CHAR = 'Tu mensaje debe contener al menos 3 caracteres';
export const CHATBOT_ERROR_ACCESSING_MEDIA_DEVICES = 'No se pudo acceder al micrófono. Por favor, verifica los permisos.';
export const CHATBOT_PLACEHOLDER_INPUT = 'Quisiera más info sobre la cursada';
export const CHATBOT_DEFAULT_WELCOME = 'Hola, ¿en que puedo ayudarte?';

export const CHATBOT_WHATSAPP_MESSAGE = ' **¡Hola!** \n En estos momentos, nuestro chatbot no está disponible. Te invitamos a comunicarte con nosotros por WhatsApp para recibir asistencia. \n [Haz clic aquí para enviar un mensaje por WhatsApp](https://api.whatsapp.com/send/?phone=5491165972111&text&type=phone_number&app_absent=0) \n ¡Gracias por tu comprensión!';

export const CHATBOT_MODE_CHATBOT = 'chatbot';
export const CHATBOT_MODE_RECOMMENDER = 'recommender';

export const CHATBOT_WELCOME_NAVIGATION = 'welcomeNavigationState';

export const CHATBOT_TOKEN_USER = 'token-user';
